import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './SuperAdminsList.css';

const SuperAdminsList = () => {
  const [superadmins, setSuperadmins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSuperAdmins();
  }, []);

  const fetchSuperAdmins = async () => {
    try {
      const response = await axios.get('/api/users/superadmins');
      setSuperadmins(response.data);
    } catch (error) {
      console.error('Failed to fetch superadmins:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="superadmins-list">
      <div className="page-header">
        <h2>Superadmins</h2>
        <Link to="/superadmin/users/superadmins/add" className="btn-primary">Add Superadmin</Link>
      </div>

      <table className="data-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Email</th>
            <th>Name</th>
            <th>Title</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          {superadmins.length === 0 ? (
            <tr>
              <td colSpan="5" style={{ textAlign: 'center' }}>No superadmins found</td>
            </tr>
          ) : (
            superadmins.map(admin => (
              <tr key={admin.id}>
                <td>{admin.username}</td>
                <td>{admin.email}</td>
                <td>{admin.first_name} {admin.last_name}</td>
                <td>{admin.title}</td>
                <td>{new Date(admin.created_at).toLocaleDateString()}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SuperAdminsList;

